import styled from 'styled-components/native';

const ErrorText = styled.Text`
  color: red;
`;

export default ErrorText;
